export function stringCapitalize(string) {
	const firstLetter = string && string.charAt(0);
	const trailingLetters = string && string.slice(1);
	let toReturn = ((firstLetter && firstLetter.toUpperCase()) || '')+((trailingLetters && trailingLetters.toLowerCase()) || '')
	return toReturn || string;
}
